/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon16Light = forwardRef('NetConnectRssIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.843 4.522a8 8 0 0 0-3.314-.508.5.5 0 0 1-.058-.998 9 9 0 0 1 9.513 9.516.5.5 0 0 1-.998-.06 7.998 7.998 0 0 0-5.143-7.95Z" }),
        React.createElement("path", { d: "M5.323 8.225a4 4 0 0 0-1.77-.2.5.5 0 1 1-.111-.994 5 5 0 0 1 5.526 5.536.5.5 0 1 1-.994-.114 4 4 0 0 0-2.65-4.228Z" }),
        React.createElement("path", { d: "M4 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
